module.exports = __webpack_public_path__ + "platform/static/media/about.4900c2fd.svg";